export const ActiveStatusEnum = {
  Active: 'A',
  Archived: 'V',
  Deleted: 'D',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ActiveStatusEnum.js